const MySubscriptions = () => {
    return (
        <div>
            <h1>My Subscriptions</h1>
        </div>
    );
};

export default MySubscriptions;
